import * as commonData from "../Common";
import * as actionType from "../constants";
export const createCustomFilter = (input) => async (dispatch) => {
  const { filter_id, ...rest } = input;
  let apiUrl = commonData.commonData().apiUrl;

  const resp = await fetch(`${apiUrl}create-custom-filter`, {
    method: "post",
    body: JSON.stringify(rest),
  });
  const rdata = await resp.json();
  if (rdata.code === 200) {
    // const filterCustom = [...this.state.customFilter];
    const newfilter = {
      ...rdata.data,
      message: rdata.message,
    };
//    localStorage.setItem("selected_filter", rdata.data.filter_id);
    dispatch({
      type: actionType.CREATE_CUSTOM_FILTER,
      payload: { newFilter: newfilter },
    });
    return rdata;
  } else {
    dispatch({
      type: actionType.CREATE_CUSTOM_FILTER_ERROR,
      payload: { code: rdata.code, message: rdata.message },
    });
  }
};
